import React from "react";
import s from "./Layout.module.css";
import { Card } from "components/common/common";

const Layout = ({ articles }) => {
  return (
    <div className={s.container}>
      {articles.map((article) => (
        <Card
          key={article.hash}
          hash={article.hash}
          title={article.title}
          created={article.created}
          description={article.shortDescription || ""}
          cover={article.cover || ""}
        />
      ))}
    </div>
  );
};

export default Layout;
